import { z } from 'zod';

export type ConfirmRegistrationPayload = z.output<typeof confirmRegistrationPayloadSchema>;
export type ConfirmRegistrationPayloadDTO = z.input<typeof confirmRegistrationPayloadSchema>;

export const confirmRegistrationPayloadSchema = z.object({
  code: z.string(),
  email: z.email(),
});
